<template>
    <b-row class="match-height">
      <b-col
lg="12"
> <b-card
      title="Confirm Item Disposal"
    >
      <b-form
          @submit.prevent="submitEditItemDisposal"
>
        <b-row>
          <b-col cols="12">
            <b-button
            type="button"
            variant="primary"
            class="mr-1"
            @click="previous()"
            >
            <feather-icon
                icon="ArrowLeftIcon"
                size="16"
                class="align-middle"
            />
            Back
            </b-button>
            <div class="devider" />
        <b-form-group>
          <label for="email">Number :</label>
          <input
            v-model="itemDisposalNumber"
            type="text"
            name="Number"
            class="form-control"
            readonly
            >
        </b-form-group>
            <b-form-group
              label="Notes"
              label-for="item_disposal_notes"
              label-cols-md="12"
            >
              <b-form-input
                id="item_disposal_notes"
                v-model="itemDisposalNotes"
                placeholder="Notes"
                readonly
              />
            </b-form-group>
            <div>
                <b-row>
                  <b-col
cols="8"
class="text-center font-weight-bold"
>
                    Item name
                  </b-col>
                  <b-col
cols="2"
class="text-center font-weight-bold"
>
                    Item Unit
                  </b-col>
                  <b-col
cols="2"
class="text-center font-weight-bold"
>
                    QTY
                  </b-col>
                </b-row>
                <p />
                <b-row
                  v-for="item in items"
                  :key="item.item_disposal_detail_item_id"
                >
                  <br>
                  <b-col
cols="6"
class="text-center"
>
                    <b-list-group>
                      <b-list-group-item
                        href="#"
                      >
                        {{ item.item.item_name }} ({{ item.item.item_code }})
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                  <b-col
cols="2"
class="text-center"
>
                    <b-list-group>
                      <b-list-group-item href="#">
                        {{
                          item.item.unit
                            ? capitalizeWords(item.item.unit.unit_name)
                            : "-"
                        }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                  <b-col
cols="2"
class="text-center"
>
                      <b-list-group-item href="#">
                        {{
                          item.item_disposal_detail_item_qty
                        }}
                      </b-list-group-item>
                  </b-col>
                  <b-col cols="12">
                    <br>
                  </b-col>
                </b-row>
              </div>
              </b-col>
          <!-- submit and reset -->
          <b-col offset-md="12">
            <b-button
              v-if="itemDisposalConfirmed==0"
              type="submit"
              variant="primary"
              class="mr-1"
            :disabled="submitButtonDisabled"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
      </b-col>
    </b-row>
  </template>
  <script>
  import {
    BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BListGroup, BListGroupItem,
    } from 'bootstrap-vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import axios from 'axios'
  import moment from 'moment-timezone'
  import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import apiEndpoints from '@/constants/apiEndpoints'

  const VersionCheck = ''
  const items = []
  const chosenItem = ref(3)
  const chosens = []
  const itemDisposalNumber = ''
  const itemDisposalNotes = ''
  const itemDisposalId = ''
  const itemDisposalConfirmed = false
  const submitButtonDisabled = false
  export default {
    components: {
      BListGroup,
      BListGroupItem,
      BCard,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BForm,
      BButton,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
     itemDisposalId,
      VersionCheck,
      items,
      chosenItem,
      chosens,
      itemDisposalNumber,
      itemDisposalNotes,
      itemDisposalConfirmed,
      submitButtonDisabled,
      }
    },
    mounted() {
        this.getDetail()
    },
    methods: {
    getFullUrl(picturePath) {
      return `${this.apiUrl}/upload/${picturePath}`
    },
    getDetail() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const item = JSON.parse(localStorage.getItem("itemDisposalDetail"))
      this.modalDetailShow = true
      this.itemDisposalNotes = item.item_disposal_notes
      this.itemDisposalConfirmed = item.item_disposal_confirmed_by !== null ? 1 : 0
      const id = item.item_disposal_id
      const obj1 = {
        title: "Created",
        content: `Item Disposal Has been Created By ${
          item.requester.user_fullname
        } at ${this.dateSimple(
          item.item_disposal_created_time,
          "YYYY-MM-DD",
        )}`,
        stepCssClass: "has-step-green",
        boxCssClass: "has-color-red",
      }
      const obj2 = {
        title: "Laboratory Manager",
        content:
          item.item_disposal_confirmed_by !== null
            ? `Item Disposal Has been Accepted by ${
                item.lab_manager.user_fullname
              } at ${this.dateSimple(
                item.item_disposal_is_accepted_by_supervisor_date,
                "YYYY-MM-DD",
              )}`
            : `Item Disposal Has not been Accepted By Laboratory Manger`,
        stepCssClass:
          item.item_disposal_is_accepted_by_supervisor === true
            ? "has-step-green"
            : "has-step-red",
      }
      this.statusItems = []
      this.statusItems.push(obj1)
      this.statusItems.push(obj2)
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DETAIL_ITEM_DISPOSALS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const joined = []
            response.data.data.map(elem => {
              const temp = {
                id: elem.item_disposal_detail_id,
                label: `${elem.item.item_name} (${elem.item.item_code})`,
                value: elem.item_disposal_detail_item_id,
                item: elem.item,
                qty: elem.item_disposal_detail_item_qty,
                unit: elem.item.unit,
              }
              joined.push(temp)
            })
            this.items = joined
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    submitEditItemDisposal() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
      this.submitButtonDisabled = true
      this.itemDisposalQtyAccepted = 0
      let numberFilled = true
      this.items.map(elem => {
        this.itemDisposalQtyAccepted += parseInt(elem.qty_accepted)
      })
      this.items.map(o => {
        if (o.qty_accepted === "") {
          numberFilled = false
        }
      })
      if (numberFilled === true) {
        const body = {
          item_disposal_id: this.itemDisposalId,
          item_disposal_items: JSON.stringify(this.items),
          time: moment(),
        }
        const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_CONFIRM_ITEM_DISPOSALS}`
      axios
        .post(url, body, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.items = []
            this.itemDisposalNotes = ""
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Item Disposal Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-item-disposals-list' })
          } else {
      this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Item Disposal Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        .catch(() => {
      this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'Item Disposal Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      } else {
      this.submitButtonDisabled = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Please Fill all the numbers",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              })
      }
    },
      getOptionLabel(option) {
        return (option && option.label) || ''
      },
      applyItem(val) {

      },
      getOptionKey(option) {
        return (option && option.value) || ''
      },
      inputSearch(search) {

      },
      removeRow(val) {
        this.chosens = this.chosens.filter(obj => (obj.value !== val))
      },
      dateFormat(value, format = 'MM/DD/YYYY') {
          return moment.utc(value).tz('Asia/Jakarta').format(format)
      },
        previous() {
            this.$router.push({ name: 'apps-item-disposals-list' })
        },
    capitalizeWords(str) {
      // Split the string into words using spaces as the separator
      const words = str.split(" ")
      // Capitalize the first letter of each word and join them back together
      const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      // Join the capitalized words into a single string with spaces
      return capitalizedWords.join(" ")
    },
    dateSimple(value, format = "YYYY-MM-DD") {
      let dateRet = ""
      if (value !== null) {
        dateRet = moment.utc(value).tz('Asia/Jakarta').format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },
    },
  }
  </script>
